module.exports = __webpack_public_path__ + "img/taurus.842c6a22.png";